import { createStore, createLogger } from 'vuex'
import userModule from './userModule'
import metaModule from './metaModule'
import scanModule from './scanModule'
import notificationsModule from './notificationModule'
import trackerModule from './trackerModule'
import metaActions from '@/store/metaModule/actionTypes'
import StoreUtil from '@/store/StoreUtil'
import { env } from '@/lib/runtimeEnv'

const modules = {
  [StoreUtil.moduleNames.meta]: metaModule as any,
  [StoreUtil.moduleNames.user]: userModule as any,
  [StoreUtil.moduleNames.notification]: notificationsModule as any,
  [StoreUtil.moduleNames.scan]: scanModule as any,
  [StoreUtil.moduleNames.tracker]: trackerModule as any,
}

const store = createStore({
  modules,
  plugins: env.VITE_DEBUG === 'true' ? [createLogger()] : [],
})

store.watch(
  (state: any) => state.meta.clientCountry,
  (country: string) => {
    store.dispatch(metaActions.FETCH_REGIONS_LIST.NAMESPACED)
  },
  { immediate: true }
)

export default store
